export const GET_ALL_ADMIN_REPORTS_DATA_SUCCESS = 'GET_ALL_ADMIN_REPORTS_DATA_SUCCESS'
export const GET_ALL_ADMIN_REPORTS_DATA_FAIL = 'GET_ALL_ADMIN_REPORTS_DATA_FAIL'
export const CLEAR_ALL_ADMIN_REPORTS_DATA = 'CLEAR_ALL_ADMIN_REPORTS_DATA'
 
export const RESPONSE_STATE_SUCCESS = 'RESPONSE_STATE_SUCCESS'
export const RESPONSE_STATE_FAIL = 'RESPONSE_STATE_FAIL' 